import {renderInputValidationFields} from './widget-utils'

import FormActions from '../edit/form-actions'
import i18n from 'scoreboard/components/i18n'
import Backbone from 'backbone'
import _ from 'lodash'
import template from './field-widget-editor.hbs'
import formHelper from 'scoreboard/components/form-helper'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import FormView from 'scoreboard/components/form-view'
import getEditorTitle from './get-editor-title'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import fieldWidgetSuggestion from './field-widget-suggestion.hbs'
import DraggableList from 'draggable-list'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import enums from 'scoreboard/components/enums'
import selects from 'scoreboard/components/selects'
import CheckboxWidgetEditor from './checkbox-widget-editor'
import { datasetFieldFilter, isJunctionLinkField } from '../dataset-field-filter'
import { getSelectableDatasets, findLinkField, getAvailableFields }
	from '../dataset-field-form-util'
import unwrapModel from 'scoreboard/components/unwrap-model'
import WidgetState from 'scoreboard/forms/model/widget-state'
const { TEXT_ONLY } = WidgetState
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { CHECKBOXES, FIELD } = FormWidgetType
import DataType from 'scoreboard/datasets/model/data-type'
import widgetMetadata from './widget-metadata'
const { TEXT, YES_NO, DATASET_LINK } = DataType
import FormActionType from '../model/form-action-type'
import inputLengthValidatorFactory
	from '../../components/validators/input-length-validator-factory'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'

const FieldWidgetEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'form-widget-editor field-widget-editor',

	events: {
		'click .add-suggestion': 'onClickAddSuggestion',
		'click .delete-suggestion': 'onClickDeleteSuggestion',
		'change [name=multiline]': 'toggleSuggestionTypeToggle',

		// #53280 make sure we are not calling this when fieldId selects in the
		// logician are changed
		'change .widget-field[name=fieldId]': 'onChangeField',
		'change [name=dataset]': 'onChangeDataset'
	},

	/**
	 * Editor for changing the attributes of a form text widget
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model
	 *
	 * @param {FormWidget} options.widget the widget's data
	 */
	initialize: function(options = {}) {
		this.options = options
		this.dataset = getDialogDatasetOrDataset(this.model)
		this.widgetType = _.get(this.options, 'widget.type')
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
		this.suggestions = []
		this.fieldId = _.get(this.options, 'widget.fieldId')
		this.valueLabelFieldId = _.get(this.options, 'widget.valueLabelFieldId')

		this.dataType = this.getFieldDatatype()
	},

	render: function() {
		let isCheckboxType = this.widgetType === CHECKBOXES
		this.$el.empty().append(template(_.extend({ isCheckboxType }, this.context())))
		if (isCheckboxType) {
			this.checkboxEditor = new CheckboxWidgetEditor({
				model: this.model,
				formView: this.formView,
				widget: this.options.widget
			})
			this.$('.panel.body .panel-content')
				.empty()
			  	.append(this.checkboxEditor.el)
			this.checkboxEditor.render()
			this.renderStateToggle()
		} else {
			this.renderDatasetDropdown()
			this.renderFieldDropdown()
			this.renderValueLabelField()
			this.renderStateToggle()
			this.renderFieldTypeDropdown()
			this.renderSuggestionTypeToggle()
			this.renderSuggestions()
			this.renderDraggableSuggestions()
			this.renderAllowTypingCheckbox()
			renderInputValidationFields.bind(this)()
			this.renderActions()
		}
		formHelper.writeToDom(this.options.widget, this.el)


		if (!isCheckboxType) {
			// #37392, #37341 conditionally hide the suggestion type toggle
			// depending on the field's data type and whether it is a primary key
			this.toggleSuggestionTypeToggle()
		}

		// Once the initial suggestion UI is rendered, determine whether the
		// suggestion label should be visible based on the allowTyping checkbox
		this.setSuggestionLabelVisibility()

		this.formView.start()
		return this
	},

	context: function() {
		return {
			title: getEditorTitle(this.options.widget),
			bannerMsg: i18n.get('forms.actions.valueChangeActionsBanner',
				i18n.get('forms.actions.actionsBannerPart2'))
		}
	},

	renderDatasetDropdown: function() {
		const container = this.$('.dataset-container')
		const datasets = getSelectableDatasets(this.model, this._getSelectedDatasetId())
		if (datasets.length <= 1) {
			container.addClass('is-not-displayed')
			return
		}

		container.removeClass('is-not-displayed')

		const select = this.$('[name=dataset]')
		selects.filtering(select, {
			options: _.map(datasets, d => unwrapModel(d)),
			accessors: { value: 'id' }
		})

		selects.val(select, this._getSelectedDatasetId())
		this.datasetMarkedField = new MarkedField({
			el: select,
			validators: [requiredValidator]
		}).render()
	},

	onChangeDataset: function(e) {
		const dataset = this.dataset.datasetsById[e.target.value]
		// Set to the linked field if there is one, then the dataset's primary
		// key field, then just the first field in the field list
		const fieldId = dataset.id == this.dataset.id
			? dataset.primaryKeyFieldId
				|| _.find(dataset.get('fields'), f => f.dataType != DATASET_LINK).id
			: findLinkField(this.model, dataset, _.get(this.options, 'widget.fieldId')).id

		// We null this out so when the value label field is rendered, the pk of
		// the selected dataset is used, if there is one
		this.valueLabelFieldId = null

		this.onChangeField({ target: { value: fieldId }})
		this.renderFieldDropdown()
	},

	onChangeField: function(e) {
		this.fieldId = e.target.value
		this.dataType = this.getFieldDatatype()
		this.toggleSuggestionTypeToggle()
		this.renderValueLabelField()
	},

	_getSelectedDatasetId: function() {
		const field = this._getField()
		if (this._isDirectLinkedField()) return field.linkedDatasetId
		return field.datasetId
	},

	_getField: function() {
		return this.dataset.combinedFieldsById[this.fieldId]
	},

	_isLinkedField: function() {
		if (_.isNil(this._getField())) return false
		return this._isDirectLinkedField() || this._isIndirectLinkedField()
	},

	_isDirectLinkedField: function() {
		return this._getField().datasetId == this.dataset.id &&
			this._getField().dataType === DATASET_LINK
	},

	_isIndirectLinkedField: function() {
		return this._getField().datasetId != this.dataset.id
	},

	_getAvailableLinkedFields: function() {
		const field = this._getField()
		const mainDataset = field.datasetId == this.dataset.id
			? this.dataset
			: this.dataset.datasetsById[this._getSelectedDatasetId()]
		const linkedDatasetId = field.datasetId == this.dataset.id
			? this._getSelectedDatasetId()
			: this.dataset.id

		const availableFieldIds = _.map(getAvailableFields(this.model, mainDataset), f => f.id)
		availableFieldIds.push(this.fieldId)

		return _.filter(mainDataset.get('fields'), f =>
			f.linkedDatasetId == linkedDatasetId && _.includes(availableFieldIds, f.id))
	},

	renderFieldDropdown: function() {
		this.$('.field-group').removeClass('is-not-displayed')
		this.fieldField && this.fieldField.remove()

		let allowedFields
		if (this._isLinkedField()) {
			// We have selected a linked dataset; show the possible linked fields
			// if there are more than one; otherwise hide this dropdown
			allowedFields = this._getAvailableLinkedFields()

			// If there is only a single option, still show the select so that
			// the user knows which field they are editing
			if (allowedFields.length < 1) {
				this.$('.field-group').addClass('is-not-displayed')
				return
			}
		} else {
			// We are just referencing a normal field on this dataset; show the
			// other normal fields in the field dropdown
			const filter = datasetFieldFilter(null, false)
			allowedFields = this.dataset.combinedFields
				.filter(f => filter(f, this.dataset))
		}

		this.$('.field-group > .field').append('<select class="widget-field" name="fieldId"></select>')
		this.fieldField = renderFieldDropdown({
			el: this.$('[name=fieldId]'),
			selectedId: this.fieldId,
			dataset: this.dataset,
			required: true,
			allowedVisibleLinkedFieldIds: [],
			filterVisibleLinkedFields: false,
			allowedFieldIds: _.map(allowedFields, f => f.id),
			excludeLinkedDatasetStyle: true
		})
	},

	renderValueLabelField: function() {
		this.$('.value-label-field-container').addClass('is-not-displayed')
		// Remove so we don't attempt to validate it when it's not being shown
		this.valueLabelDropdown && this.valueLabelDropdown.remove()

		if (!this.isDatasetLink()) return

		const field = _.find(this.dataset.combinedFields, f => f.id == this.fieldId)

		this.$('.value-label-field-container')
			.removeClass('is-not-displayed')
			.append('<select name="valueLabelFieldId"></select>')

		// Get the linked dataset, depending on whether this field is a linked
		// field on this dataset or a different one
		const thisDatasetId = this.dataset.get('id')
		const datasetIdToUse = field.datasetId === thisDatasetId
			? field.linkedDatasetId : field.datasetId
		const linkDataset = this.dataset.datasetsById[datasetIdToUse]
		// Remove the field that this widget is editing
		const allowedFieldIds = _.filter(linkDataset.get('fields'),
			f => f.linkedDatasetId !== this.dataset.id)
			.map(f => f.id)

		// #45708 we use the pk field for the label if nothing is selected, so go
		// ahead and show it as selected
		const selectedId = this.valueLabelFieldId || linkDataset.get('primaryKeyFieldId')
		this.valueLabelDropdown = renderFieldDropdown({
			el: this.$('[name="valueLabelFieldId"]'),
			required: true,
			dataset: linkDataset,
			allowedFieldIds,
			selectedId,
			allowedVisibleLinkedFieldIds: {}
		})
	},

	isDatasetLink: function() {
		if (!this.fieldId || !this.dataset) return false

		const field = this.dataset.combinedFieldsById[this.fieldId]
		if ((field.datasetId === this.dataset.id || field.linkedDatasetId === this.dataset.id)
			&& field.dataType === DATASET_LINK) return true

		return isJunctionLinkField(field, this.dataset)
	},

	renderStateToggle: function() {
		// circular dependency
		let states = widgetMetadata.states[FIELD]
		this.stateToggle = new LabeledToggle({
			name: 'state',
			value: _.get(this.options.widget, 'state'),
			options: _.filter(enums.toOptionData('widgetState'), item => {
				if (_.includes(states, item.id)) {
					return _.extend(item, { value: item.id })
				}
			})
		})

		this.$('.widget-state .labeled-toggle-container').append(this.stateToggle.el)
		this.stateToggle.render()
		this.stateToggle.on('change', () => {
			this.formView.change()
			this.toggleSuggestionTypeToggle()
			// #57684
			// After suggestions are re-rendered from widget state toggling,
			// ensure the label input visibility is set correctly
			this.setSuggestionLabelVisibility()
		})
	},

	renderFieldTypeDropdown: function() {
		this.multiline = this.$('[name=multiline]')
		selects(this.multiline)
	},

	renderInputValidationDropdown: function() {
		let options = _.map(enums.toOptionData('formWidgetInputValidationType'),
			option => _.extend(option, {
				value: option.id,
				selected: this.options.widget.inputValidationType === option.id
			}))

		let allowTypingNewValues = this.$('input[name="allowTyping"]').is(':checked')
		if ((this.dataType !== TEXT && !isNumericDataType(this.dataType)) ||
			!allowTypingNewValues) {
			options = options.filter(
				option => option.id === 'input-required' || option.id === 'input-optional')
		}

		let inputValidationDropdown = this.$('[name=inputValidationType]')
		selects(inputValidationDropdown, { options })
		inputValidationDropdown.on('change', e => this.onChangeInputValidationDropdown(e))

		// render the correct field
		inputValidationDropdown.change()
	},

	renderSuggestionTypeToggle: function() {
		this.suggestionTypeToggle = new LabeledToggle({
			name: 'suggestionType',
			value: _.get(this.options.widget, 'suggestionType') || 'none',
			options: _.map(enums.toOptionData('formWidgetSuggestionType'),
				item => _.extend(item, { value: item.id }))
		})

		this.$('.labeled-toggle-container').append(this.suggestionTypeToggle.el)
		this.suggestionTypeToggle.render()
		this.suggestionTypeToggle.on('change', () => {
			this.formView.change()
			this.onChangeSuggestionType()
		})
	},

	renderSuggestions: function() {
		let suggestions = _.get(this.options, 'widget.suggestions')
		this.suggestions = []
		if (_.isEmpty(suggestions)) {
			this.renderSuggestion()
		}
		_.each(suggestions, suggestion => {
			this.renderSuggestion(suggestion)
		})
		this.toggleSuggestionDeleteControls()
	},

	renderSuggestion: function(suggestion) {
		this.$('.suggestions-list .suggestions').append(fieldWidgetSuggestion(suggestion))
		let suggestionEl = this.$('.suggestions-list .suggestions .suggestion').last()
		let suggestionInput = suggestionEl.find('input.input-value')
		let suggestionLabel = suggestionEl.find('input.input-label')
		if (suggestion) {
			suggestionInput.val(suggestion?.value)
			suggestionLabel.val(suggestion?.label)
		}

		// Set validators according to data type of the underlying field
		let validators = [inputLengthValidatorFactory({
			high: 2000
		})]
		let evaluator = null
		if (isNumericDataType(this.dataType)) {
			validators.push(numericValidator)
			evaluator = numericEvaluator

			// #58145
			// In case we're changing from text to numeric, we need to clear the
			// value if it cannot be parsed as a number
			const inputVal = suggestionInput.val()
			if (inputVal && isNaN(Number(inputVal))) {
				suggestionInput.val(null)
			}
		}
		this.suggestions.push(new MarkedField({
			el: suggestionInput,
			validators,
			evaluator,
			dataType: this.dataType == TEXT ? null : this.dataType
		}).render())
	},

	/*
	 * #51640 Do not allow suggestion labels if the user can manually
	 * type in values
	 */
	setSuggestionLabelVisibility: function() {
		let allowTyping = this.$('input[name="allowTyping"]').is(':checked')
		this.$('.suggestion').toggleClass('is-allowing-typing', allowTyping)
	},

	renderDraggableSuggestions: function() {
		let list = this.$('.suggestions-list ul.suggestions')
		if (list.find('.suggestion').length > 1) {
			this.draggableSuggestions = new DraggableList(list[0])
			this.draggableSuggestions.on('move', this.formView.change.bind(this.formView))
		}
	},

	renderActions: function() {
		// #57484 allowed action types should not include 'SEND_ALERT' action
		// Retrieve all action types from the centralized enum, excluding 'SEND_ALERT'
		let allowedActionTypes =
			Object.values(FormActionType).filter(type => type !== FormActionType.SEND_ALERT)

		this.actions = new FormActions({
			model: this.model,
			statements: this.options.widget.statements,
			title: i18n.get('forms.actions.valueChangeActions'),
			formView: this.formView,
			emptyMessage: i18n.get('forms.actions.emptyValueChange'),
			currentWidget: this.options.widget,
			allowedActionTypes
		})
		this.$('.actions-container').append(this.actions.el)
		this.actions.render()
	},

	toggleSuggestionDeleteControls: function() {
		this.$('.suggestion .delete-suggestion')
			.toggleClass('is-not-displayed', this.suggestions.length == 1)
	},

	renderAllowTypingCheckbox: function() {
		this.$('input[name="allowTyping"]')
			.prop('checked', this.options?.widget?.allowTyping)
			.on('change', () => {
				this.renderInputValidationDropdown()
				this.setSuggestionLabelVisibility()
			})
	},

	toggleSuggestionTypeToggle: function() {
		let datasetFieldId = this.fieldId || this.$('[name=fieldId]').val()
		let primaryKeyFieldId = this.model.get('dataset').primaryKeyFieldId
		let multiline = this.multiline?.val() === 'true'
		let textDataType = this.dataType === TEXT

		let hideValues =
			(!textDataType && !isNumericDataType(this.dataType)) ||
			(datasetFieldId == primaryKeyFieldId) ||
		  	(textDataType && multiline)
		// rerender the suggestions' marked fields to account for changes
		// in the field's datatype
		this.$('.suggestions-list .suggestions')
			.empty()
		_.invokeMap(this.suggestions, 'remove')
		this.renderSuggestions()
		this.renderDraggableSuggestions()

		if (hideValues) {
			this.$('.suggestions-list')
				.addClass('is-not-displayed')

			this.$('input[name="allowTyping"]')
				.prop('checked', true)
		} else {
			// This will take care of showing the suggestion list in the
			// appropriate cases
			this.onChangeSuggestionType()
		}

		let stateToggleVal = this.stateToggle.val()
		let displayOnlyField = stateToggleVal === TEXT_ONLY

		// Multiline are just for text
		this.$('label.type').toggleClass('is-not-displayed', !textDataType || displayOnlyField)
		this.$('.field-group').toggleClass('field-row', textDataType && !displayOnlyField)

		// Always hide the toggle and checkbox for non numeric/text fields and
		// always show for them
		this.$('.values-to-show, .allow-typing')
			.toggleClass('is-not-displayed', hideValues)

		if (displayOnlyField) {
			this.$('.values-to-show, .allow-typing, .input-validation, ' +
				'.input-validation-fields, .suggestions-list')
				.addClass('is-not-displayed')
		} else {
			this.$('.input-validation, .input-validation-fields').removeClass('is-not-displayed')
			this.renderInputValidationDropdown()
		}
	},

	onClickAddSuggestion: function() {
		this.renderSuggestion()
		this.renderDraggableSuggestions()
		this.toggleSuggestionDeleteControls()
		this.setSuggestionLabelVisibility()
		this.formView.change()
	},

	onClickDeleteSuggestion: function(e) {
		let valueEl = this.getSuggestionEl(e)
		const markedField = valueEl.find('.marked-field').data('view')
		_.remove(this.suggestions, s => s == markedField)
		_.invokeMap([markedField, valueEl], 'remove')
		this.toggleSuggestionDeleteControls()
		this.formView.change()
	},

	getSuggestionEl: function(e) {
		return this.$(e.target).closest('.suggestion')
	},

	onChangeSuggestionType: function() {
		this.$('.suggestions-list').toggleClass(
			'is-not-displayed', this.suggestionTypeToggle.val() !== 'specific-values')

		let noneSelected = this.suggestionTypeToggle.val() === 'none'
		this.$('input[name="allowTyping"]')
			.prop('disabled', noneSelected)
			.prop('checked', (i, val) => {
				if (noneSelected) {
					return true
				}
				return val
			})
		this.setSuggestionLabelVisibility()
		this.renderInputValidationDropdown()
	},

	onChangeInputValidationDropdown: function(e) {
		this.clearErrors()
		let dropdownValue = e.target.value
		this.$('.input-validation-fields')
			.find('label')
			.addClass('is-not-displayed')
			.filter(`.${dropdownValue}`)
			.removeClass('is-not-displayed')
		this.$('.length-group')
			.toggleClass('field-row', dropdownValue == 'minimum-maximum-length')
	},

	getSuggestionData: function() {
		return _.map(this.$('.suggestion'), valueEl => {
			let suggestion = formHelper.readFromDom(valueEl)
			suggestion.id = this.$(valueEl).data('id')
			// #57707
			// Using the name `value` or `label` will cause readFromDom to
			// overwrite other elements with the same name (such as the label
			// text at the top of `field-widget-editor.hbs`). We need to use
			// `suggestionValue` and `suggestionLabel` to avoid this, but
			// preserve original naming for later use of the suggestion object
			suggestion.value = suggestion?.suggestionValue
			suggestion.label = suggestion?.suggestionLabel
			return suggestion
		})
	},

	getFieldDatatype: function() {
		if (this.widgetType === CHECKBOXES) {
			return YES_NO
		}
		if (this._isLinkedField()) {
			return DATASET_LINK
		}
		const dataset = _.get(this.model, 'dataset')
		const underlyingField = dataset.getUnderlyingField(this.fieldId)
		return underlyingField?.dataType
	},

	submit: function() {
		// only read from the panels and not from the logician as they have
		// overlapping fields. We will get the statement data separately
		let data = _.extend({}, formHelper.readFromDom(this.$('.panel')),
			{ type: this.widgetType })
		data.multiline = data.multiline === 'true'
		if (this.widgetType === CHECKBOXES) {
			data.type = CHECKBOXES
			data.childWidgets = this.checkboxEditor.getData()
		} else {
			data.suggestions = this.getSuggestionData()
			data.statements = this.actions.getData()
		}

		this.trigger('done', data)
	},

	clearErrors: function() {
		this.minimumLengthMarkedField.clearError()
		this.maximumLengthMarkedField.clearError()
		this.customExpressionMarkedField.clearError()
	},

	autoRemove: true
})

export default FieldWidgetEditor

FieldWidgetEditor.__filename__ = 'forms/widgets/field-widget-editor.js'
